import { PCB_CORE_URL } from "./config";

const ACCESS_KEY = "access_token";
const REFRESH_KEY = "refresh_token";
const LEGACY_TOKEN_KEY = "token";
const USER_STORE_KEY = "user-store";

const storage = (() => {
  try {
    return window.sessionStorage;
  } catch (_) {
    return null;
  }
})();

const legacyStorage = (() => {
  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
})();

function read(key) {
  return storage?.getItem(key) || "";
}

function write(key, value) {
  if (!storage) return;
  if (value) storage.setItem(key, value);
  else storage.removeItem(key);
}

export function getAccessToken() {
  const current = read(ACCESS_KEY);
  if (current) return current;

  const legacy = legacyStorage?.getItem(ACCESS_KEY) || legacyStorage?.getItem(LEGACY_TOKEN_KEY) || "";
  const refresh = legacyStorage?.getItem(REFRESH_KEY) || "";
  if (legacy || refresh) {
    setAuthTokens({ access: legacy, refresh });
  }
  return legacy;
}

export function getRefreshToken() {
  const current = read(REFRESH_KEY);
  if (current) return current;

  const legacy = legacyStorage?.getItem(REFRESH_KEY) || "";
  if (legacy) setAuthTokens({ access: getAccessToken(), refresh: legacy });
  return legacy;
}

export function setAuthTokens({ access = "", refresh = "" } = {}) {
  write(ACCESS_KEY, access);
  write(REFRESH_KEY, refresh);
  legacyStorage?.removeItem(ACCESS_KEY);
  legacyStorage?.removeItem(REFRESH_KEY);
  legacyStorage?.removeItem(LEGACY_TOKEN_KEY);
}

export function clearAuthSession() {
  storage?.removeItem(ACCESS_KEY);
  storage?.removeItem(REFRESH_KEY);
  legacyStorage?.removeItem(ACCESS_KEY);
  legacyStorage?.removeItem(REFRESH_KEY);
  legacyStorage?.removeItem(LEGACY_TOKEN_KEY);
  legacyStorage?.removeItem("user");
  legacyStorage?.removeItem(USER_STORE_KEY);
}

export async function refreshAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) {
    clearAuthSession();
    return "";
  }

  const base = (PCB_CORE_URL || "").replace(/\/+$/, "");
  const response = await fetch(`${base}/api/token/refresh/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh }),
  });

  if (!response.ok) {
    clearAuthSession();
    return "";
  }

  const data = await response.json().catch(() => ({}));
  const nextAccess = data.access || "";
  const nextRefresh = data.refresh || refresh;
  setAuthTokens({ access: nextAccess, refresh: nextRefresh });
  return nextAccess;
}

export function authHeader() {
  const token = getAccessToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function authenticatedFetch(url, options = {}) {
  const makeOptions = (token) => ({
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  let token = getAccessToken();
  let response = await fetch(url, makeOptions(token));
  if (response.status !== 401) return response;

  token = await refreshAccessToken();
  if (!token) return response;
  return fetch(url, makeOptions(token));
}
